export enum PassportTabsEnum {
  COMMON = 'COMMON',
  CONTROL = 'CONTROL',
  PROSECUTOR = 'PROSECUTOR',
  FACE = 'FACE',
  RESULT = 'RESULT',
  VIOLATION = 'VIOLATION',
}
